import { io } from 'socket.io-client';

// =============================================================================
// chat-realtime.ts — Fabrique de socket temps réel (COM-01), surface MINCE.
// =============================================================================
// DEC-31 §1/§3 : le socket est LIVRAISON-SEULE. Il ne transporte QUE des signaux MINCES
// (`{ threadId, messageId }`) et ne fait QUE déclencher un refetch REST (voir use-chat-realtime.ts).
// AUCUNE donnée métier n'est dérivée du payload socket ; le CONTENU vient TOUJOURS du REST RLS.
//
// Connexion (parité realtime.config.ts côté API) : namespace `/rt`, path `/api/socket.io/`, MÊME ORIGINE
// (le LB route `/api/*` → api ; le préfixe global HTTP ne couvre PAS Socket.IO), `withCredentials:true`
// (le cookie de session httpOnly voyage sur le handshake same-origin). Le socket n'est JAMAIS la frontière
// de sécurité : le cloisonnement est porté serveur (résolution de session + garde RLS du `thread:join`).

/**
 * Surface MINIMALE d'un socket réellement utilisée par le hook (structurellement satisfaite par le
 * `Socket` de socket.io-client). Permet aux tests d'injecter un double sans dépendre du type complet.
 */
export interface ChatSocketLike {
  on(event: string, listener: (...args: unknown[]) => void): unknown;
  off(event: string, listener?: (...args: unknown[]) => void): unknown;
  emit(event: string, ...args: unknown[]): unknown;
  disconnect(): unknown;
}

/**
 * Ouvre un socket sur le namespace temps réel `/rt`, path `/api/socket.io/`, même origine, cookies inclus.
 * `transports` websocket + polling (repli). `autoConnect` par défaut : la connexion s'établit au montage.
 */
export function createChatSocket(): ChatSocketLike {
  return io('/rt', {
    path: '/api/socket.io/',
    withCredentials: true,
    transports: ['websocket', 'polling'],
  }) as unknown as ChatSocketLike;
}
